/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import { Box } from 'grommet'
import { HorizontalBarChart } from 'grommet-controls/chartjs'
import moment from "moment";

class WeeksChart extends React.Component {
  
  render() {
    const labels = []
    const activities = [{
      label: "Nombre d'Activités",
      borderWidth: 1,
      data: []
    }]
    const distances = [{
      label: "Distance (km)",
      borderWidth: 1,
      data: []
    }]
    const times = [{
      label: "Temps (Heure)",
      borderWidth: 1,
      data: []
    }]
    const elevations = [{
      label: "Dénivelé (m)",
      borderWidth: 1,
      data: []
    }]

    this.props.activities.forEach(week => {
      console.log(week)
      labels.push("Semaine " + week.node.semaine)
      activities[0].data.push(Number(week.node.nombredactivites))
      distances[0].data.push(Number(week.node.strdistance.replace(",", '.').replace('_','')))
      times[0].data.push(moment.duration(week.node.tempshhmmss).asHours())
      elevations[0].data.push(week.node.elevationm)
    });
    console.log(activities, distances, times, elevations)
    
    return(
      <Box
        direction='row-responsive'
      >
        <Box >
          <HorizontalBarChart
            data={{
              labels: labels,
              datasets: activities
            }}
          />
        </Box>
        <Box >
          <HorizontalBarChart
            data={{
              labels: labels,
              datasets: distances
            }}
          />
        </Box>
        <Box >
          <HorizontalBarChart
            data={{
              labels: labels,
              datasets: times
            }}
          />
        </Box>
        <Box >
          <HorizontalBarChart
            data={{
              labels: labels,
              datasets: elevations
            }}
          />
        </Box>
      </Box>
    )
  }
}

export default WeeksChart
